import styled from "styled-components";

export const ProductContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
`;

export const ProductName = styled.span`
  font-weight: bold;
`;

export const TooltipContent = styled.div`
  text-align: center;
  padding: 10px;
  background-color: #ffffff;
  border-radius: 8px;
  color: #333;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.5;
`;

export const TooltipCategory = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TooltipCircle = styled.span<{ backgroundColor: string }>`
  display: inline-block;
  width: 12px;
  height: 12px;
  background-color: ${(props) => props.backgroundColor};
  border-radius: 50%;
`;

export const TooltipDot = styled.span<{ backgroundColor: string }>`
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: ${(props) => props.backgroundColor};
  border-radius: 50%;
  cursor: pointer;
`;

export const Badge = styled.span<{ backgroundColor: string; color: string }>`
  background-color: ${(props) => props.backgroundColor};
  color: ${(props) => props.color};
  border-radius: 16px;
  padding: 2px 8px;
  font-size: 0.75rem;
  font-weight: 500;
`;

export const ProductOrderContainer = styled.div`
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 16px;
  background-color: #f9f9f9;
`;

export const ProductOrderLink = styled.a`
  font-weight: bold;
  font-size: 1rem;
  color: #1976d2;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;